/* eslint-disable max-len */
<template>
  <div class="SignUp" :class="classes">
    <div class="SignUp__backgrounds" aria-hidden="true" role="presentation">
      <div
        class="SignUp__background SignUp__background--sky"
        role="presentation"
      />
      <div
        class="SignUp__background SignUp__background--back-mountains"
        role="presentation"
      />
      <div
        class="SignUp__background SignUp__background--middle-mountains"
        role="presentation"
      />
      <div
        class="SignUp__background SignUp__background--truck"
        role="presentation"
      />
      <div
        class="SignUp__background SignUp__background--front-rocks"
        role="presentation"
      />
      <div
        class="SignUp__background SignUp__background--cloud-1"
        role="presentation"
      />
      <div
        class="SignUp__background SignUp__background--cloud-2"
        role="presentation"
      />
      <div
        class="SignUp__background SignUp__background--cloud-3"
        role="presentation"
      />
      <div
        class="SignUp__background SignUp__background--edges"
        role="presentation"
      />
    </div>
    <div class="SignUp__main">
      <b-container>
        <div class="SignUp__page">
          <ValidationObserver ref="observer" v-slot="{ handleSubmit }" slim>
            <b-form @submit="handleSubmit(onSubmit)" id="sign-up-form" novalidate>
              <PersonalInfo v-if="current_route === 'personalInfo'" :does_user_exist="does_user_exist" @onValidate="validateForm"/>
              <VehicleInfo v-if="current_route === 'vehicleInfo'" @onValidate="validateForm"/>
              <TireInfo v-if="current_route === 'tireInfo'" @onValidate="validateForm"/>
              <GearInfo v-if="current_route === 'gearInfo'" @onValidate="validateForm"/>
              <ContactInfo v-if="current_route === 'contactInfo'" @onValidate="validateForm"/>
              <SocialInfo v-if="current_route === 'socialInfo'" @onValidate="validateForm"/>
              <EnthusiastInfo v-if="current_route === 'enthusiastInfo'" @onValidate="validateForm"/>
            </b-form>
          </ValidationObserver>
        </div>
        <div class="SignUp__next text-center my-5">
          <p class="label mb-4" v-if="current_route === 'personalInfo'">
            LIMITED spots left this month!
          </p>
          <b-button v-if="current_route === 'enthusiastInfo'" :disabled="is_form_invalid" class="SignUp__button btn-double-outline btn-double-outline--normal" @click="updateCrewMember">
            Submit
            <span class="SignUp__button-icon"><b-icon-arrow-right /></span>
          </b-button>
          <b-button v-else-if="current_route === 'personalInfo'" :disabled="is_form_invalid" class="SignUp__button btn-double-outline btn-double-outline--normal" @click="checkIfCrewMemberExists">
            <span class="SignUp__button-label">Next: </span>{{ button_label }}
            <span class="SignUp__button-icon"><b-icon-arrow-right /></span>
          </b-button>
          <b-button v-else ref="signUpButton" :disabled="is_form_invalid" class="SignUp__button btn-double-outline btn-double-outline--normal" :to="{ name: next_route }">
            <span class="SignUp__button-label">Next: </span>{{ button_label }}
            <span class="SignUp__button-icon"><b-icon-arrow-right /></span>
          </b-button>
        </div>
      </b-container>
    </div>
    <footer class="SignUp__footer">
      <div class="copyright">
       <ul>
        <li>
          <span>&copy;{{ current_year }} Nitto Tire U.S.A. Inc</span> |
        </li>
        <li>
          <a href="https://www.nittotire.com/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a> |
        </li>
        <li>
          <a href="https://www.nittotire.com/terms/" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a> |
        </li>
        <li>
          <a href="#" role="button" aria-haspopup="dialog" data-faux="c-settings">Cookie Settings</a>
        </li>
      </ul>
      </div>
    </footer>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import PersonalInfo from '@/components/PersonalInfo.vue';
import VehicleInfo from '@/components/VehicleInfo.vue';
import TireInfo from '@/components/TireInfo.vue';
import GearInfo from '@/components/GearInfo.vue';
import ContactInfo from '@/components/ContactInfo.vue';
import SocialInfo from '@/components/SocialInfo.vue';
import EnthusiastInfo from '@/components/EnthusiastInfo.vue';
import { trackCustomEvent } from '../utils/tracking';

export default {
  name: 'SignUp',
  components: {
    ValidationObserver,
    PersonalInfo,
    VehicleInfo,
    TireInfo,
    GearInfo,
    ContactInfo,
    SocialInfo,
    EnthusiastInfo,
  },
  props: {
    next_route: { type: String, required: true },
    button_label: { type: String, default: '' },
    final_step: { type: Boolean, default: false },
  },
  data() {
    return {
      is_form_invalid: true,
      does_user_exist: false,
      current_year: new Date().getFullYear(),
    };
  },
  mounted() {
    this.removeAriaDisabled();
  },
  watch: {
    current_route() {
      this.$nextTick(() => this.validateForm());
    },
    is_form_invalid(newVal) {
      if(newVal === true){
       this.removeAriaDisabled();
      }
    },
  },
  computed: {
    current_route() {
      return this.$route.name;
    },
    classes() {
      return {
        [`SignUp--${String(this.current_route).toLowerCase()}`]: true,
      };
    },
  },
  created() {
    const beforeUnloadListener = (event) => {
      event.preventDefault();
      // eslint-disable-next-line
      return event.returnValue = 'Leaving the site or navigating backwards at this point will lose your information';
    };

    const onUnloadListener = () => {
      if (onUnloadListener.hasUnloaded) { return; }
      onUnloadListener.hasUnloaded = true;

      const url = `${process.env.VUE_APP_API_BASE_URL}crewmember/delete`;
      const data = this.$store.getters.getDeleteCrewMember;
      navigator.sendBeacon(url, data);
    };

    // Hack: store reference of method for removal on the confirmation screen
    if (window.NittoPitcrew) {
      window.removeEventListener('beforeunload', window.NittoPitcrew.beforeUnloadListener, { capture: true });
      window.removeEventListener('unload', window.NittoPitcrew.onUnloadListener);
      window.removeEventListener('pagehide', window.NittoPitcrew.onUnloadListener);
    } else {
      window.NittoPitcrew = {};
    }

    window.NittoPitcrew.beforeUnloadListener = beforeUnloadListener;
    window.NittoPitcrew.onUnloadListener = onUnloadListener;

    window.addEventListener('beforeunload', beforeUnloadListener, { capture: true });
    window.addEventListener('unload', onUnloadListener);
    window.addEventListener('pagehide', onUnloadListener);
  },
  methods: {
    removeAriaDisabled() {
      this.$nextTick(() => {
        const signUpBtn = this.$refs.signUpButton && this.$refs.signUpButton.$el;
        if (signUpBtn) {
          signUpBtn.removeAttribute('aria-disabled');
        }
      });
    },
    onSubmit(event) {
      event.preventDefault();
    },
    async validateForm() {
      const isValid = await this.$refs.observer.validate({ silent: true });
      // console.log('validateForm:: ', isValid);
      this.is_form_invalid = !isValid;
    },
    async updateCrewMember() {
      try {
        const path = 'crewmember';
        const data = this.$store.getters.getUpdateCrewMember;
        await this.axios.patch(path, data);

        this.$router.push('/confirmation');
      } catch (error) {
        console.log(`Error: ${error}`);
        trackCustomEvent('Error', 'Crew Member Creation', error);
      }
    },
    async checkIfCrewMemberExists() {
      try {
        const path = 'crewmember/exists';
        const params = {
          email: this.$store.state.Email,
        };

        const results = await this.axios.get(path, { params });
        if (results.data.exists) {
          this.does_user_exist = true;
          return;
        }

        this.$router.push({ name: this.next_route });
      } catch (error) {
        console.log(`Error: ${error}`);
        trackCustomEvent('Error', 'Crew Member Exists', error);
      }
    },
  },
};
</script>

<style lang="scss">
@import '../assets/styles/_breakpoints.scss';

.SignUp {
  @include media-breakpoint-down(lg) {
    padding-bottom: 60px;
  }

  &__backgrounds {
    position: absolute;
    top: 0;
    left: 50%;
    width: 100%;
    max-width: 1920px;
    height: 100%;
    z-index: 1;
    min-height: 900px;
    transform: translateX(-50%);
    overflow: hidden;

    @include media-breakpoint-down(sm) {
      min-height: 760px;
    }

    .SignUp--socialinfo & {
      min-height: 1100px;
     @include media-breakpoint-down(sm) {
        min-height: 1060px;
      }
    }
  }

  &__background {
    position: absolute;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    transition: transform 240ms ease-out;

    &--sky {
      background-image: url('../assets/images/Sky 1.png');
      height: 100%;
      top: 0;
      left: 50%;
      max-width: 1920px;
      transform: translateX(-50%);

      @include media-breakpoint-down(md) {
        left: 0;
        transform: translateX(0);
        background-image: url('../assets/images/Sky-m.png');
      }
    }

    &--back-mountains {
      background-image: url('../assets/images/Back mountains 1.png');
      height: 391px;
      bottom: 0;
      left: 50%;
      max-width: 1920px;
      transform: translateX(-50%);
      transition: transform 2s ease-in-out;

      @include media-breakpoint-down(md) {
        background-image: url('../assets/images/back-mountains-m.png');
        height: 200px;
        left: 0;
        transform: translateX(0);
      }

      @include media-breakpoint-down(sm) {
        height: 120px;
      }

      .SignUp--vehicleinfo & {
        transform: translateX(-50.3%);

        @include media-breakpoint-down(sm) {
          transform: translateX(-1%);
        }
      }

      .SignUp--tireinfo & {
        transform: translateX(-50.4%);

        @include media-breakpoint-down(sm) {
          transform: translateX(-2%);
        }
      }

      .SignUp--gearinfo & {
        transform: translateX(-50.5%);

        @include media-breakpoint-down(sm) {
          transform: translateX(-3%);
        }
      }

      .SignUp--contactinfo & {
        transform: translateX(-50.6%);

        @include media-breakpoint-down(sm) {
          transform: translateX(-4%);
        }
      }

      .SignUp--socialinfo & {
        transform: translateX(-51%);

        @include media-breakpoint-down(sm) {
          transform: translateX(-5%);
        }
      }

      .SignUp--enthusiastinfo & {
        transform: translateX(-53%);

        @include media-breakpoint-down(sm) {
          transform: translateX(-6%);
        }
      }
    }

    &--middle-mountains {
      background-image: url('../assets/images/middle mountains 1.png');
      height: 556px;
      bottom: 0;
      right: -100px;
      max-width: 1175px;
      transition: transform 2s ease-in-out;


       @include media-breakpoint-down(md) {
        background-image: url('../assets/images/middle-mountains-m.png');
        height: 400px;
        bottom: 0;
        left: 0;
        right: auto;
        transform: translateX(0);
      }

      @include media-breakpoint-down(sm) {
        height: 260px;
      }


      .SignUp--vehicleinfo & {
        transform: translateX(0.2%);
      }

      .SignUp--tireinfo & {
        transform: translateX(0.4%);
      }

      .SignUp--gearinfo & {
        transform: translateX(0.4%);
      }

      .SignUp--contactinfo & {
        transform: translateX(0.5%);
      }

      .SignUp--socialinfo & {
        transform: translateX(0.6%);
      }

      .SignUp--enthusiastinfo & {
        transform: translateX(0.65%);
      }
    }

    &--truck {
      background-image: url('../assets/images/Truck.png');
      height: 200px;
      bottom: 30px;
      left: 50%;
      max-width: 472px;
      transform: translateX(-200%);
      transition: transform 2500ms ease-out;

      @include media-breakpoint-down(md) {
        background-image: url('../assets/images/Truck-m.png');
        height: 114px;
        max-width: 272px;
        left: 0;
        transform: translate(-140px, 0) rotate(8deg);
        display: none;
      }

      @include media-breakpoint-down(sm) {
        bottom: 20px;
        transform: translate(-190px, 0) rotate(8deg);
      }

      .SignUp--vehicleinfo & {
        animation: truck-animation-1 2.5s;
        transform: translate(-170%, -0.5%) rotate(-1.5deg);

        @include media-breakpoint-down(sm) {
          animation: none;
          transform: translate(-120px, 0) rotate(-8deg);
        }
        @media (prefers-reduced-motion) {
          animation: none;
        }
      }

      .SignUp--tireinfo & {
        animation: truck-animation-2 2.5s;
        transform: translate(-140%, -20.5%) rotate(-6.5deg);

        @include media-breakpoint-down(sm) {
          animation: none;
          transform: translate(-40px, -20px) rotate(-2deg);
        }
        @media (prefers-reduced-motion) {
          animation: none;
        }
      }

      .SignUp--gearinfo & {
        animation: truck-animation-3 2.5s;
        transform: translate(-110%, -30.5%) rotate(-22.5deg);

        @include media-breakpoint-down(sm) {
          animation: none;
          transform: translate(30px, -40px) rotate(5deg);
        }
        @media (prefers-reduced-motion) {
          animation: none;
        }
      }

      .simple-animations .SignUp--gearinfo & {
        animation: none;
        transform: translate(-110%, -30.5%) rotate(-22.5deg);

         @include media-breakpoint-down(sm) {
          animation: none;
          transform: translate(80px, -60px) rotate(10deg);
        }
        @media (prefers-reduced-motion) {
          animation: none;
        }
      }

      .SignUp--contactinfo & {
        animation: truck-animation-4 2.5s;
        transform: translate(-60%, -75.5%) rotate(-13.5deg);

        @include media-breakpoint-down(sm) {
          animation: none;
          transform: translate(80px, -60px) rotate(10deg);
        }
        @media (prefers-reduced-motion) {
          animation: none;
        }
      }

      .SignUp--socialinfo & {
        animation: truck-animation-5 2.5s;
        transform: translate(-10%, -85.5%) rotate(-2.5deg);

        @include media-breakpoint-down(sm) {
          animation: none;
          transform: translate(110px, -60px) rotate(0deg);
        }
        @media (prefers-reduced-motion) {
          animation: none;
        }
      }

      .SignUp--enthusiastinfo & {
        animation: truck-animation-6 2.5s;
        transform: translate(80%, -105.5%) rotate(1.5deg);

        @include media-breakpoint-down(sm) {
          animation: none;
          transform: translate(170px, -60px) rotate(12deg);
        }
        @media (prefers-reduced-motion) {
          animation: none;
        }
      }

      @keyframes truck-animation-1 {
        from {
          transform: translateX(-200%);
        }

        15% {
          transform: translate(-195%, -0.5%) rotate(-1.5deg);
        }

        30% {
          transform: translate(-190%, 0);
        }

        45% {
          transform: translate(-180%, -0.5%) rotate(-1.5deg);
        }

        60% {
          transform: translate(-175%, 0);
        }
      }

      @keyframes truck-animation-2 {
        from {
          transform: translate(-170%, -0.5%) rotate(-1.5deg);
        }

        15% {
          transform: translate(-165%, -4.5%) rotate(-8.5deg);
        }

        30% {
          transform: translate(-160%, -8%) rotate(-7.5deg);
        }

        45% {
          transform: translate(-155%, -12.5%) rotate(-8.5deg);
        }

        60% {
          transform: translate(-150%, -15%) rotate(-6.5deg);
        }

        80% {
          transform: translate(-145%, -18%) rotate(-9.5deg);
        }
      }

      @keyframes truck-animation-3 {
        from {
          transform: translate(-140%, -12.5%) rotate(-10.5deg);
        }

        15% {
          transform: translate(-135%, -18.5%) rotate(-14.5deg);
        }

        30% {
          transform: translate(-130%, -23.5%) rotate(-12.5deg);
        }

        45% {
          transform: translate(-125%, -25.5%) rotate(-17.5deg);
        }

        60% {
          transform: translate(-120%, -24.5%) rotate(-14.5deg);
        }

        80% {
          transform: translate(-115%, -28.5%) rotate(-16.5deg);
        }

        to {
          transform: translate(-110%, -30.5%) rotate(-22.5deg);
        }
      }

      @keyframes truck-animation-4 {
        from {
          transform: translate(-110%, -30.5%) rotate(-22.5deg);
        }

        15% {
          transform: translate(-95%, -40.5%) rotate(-18.5deg);
        }

        30% {
          transform: translate(-85%, -45.5%) rotate(-20.5deg);
        }

        45% {
          transform: translate(-75%, -50.5%) rotate(-15.5deg);
        }

        60% {
          transform: translate(-70%, -55.5%) rotate(-16.5deg);
        }

        80% {
          transform: translate(-65%, -65.5%) rotate(-10.5deg);
        }
      }

      @keyframes truck-animation-5 {
        from {
          transform: translate(-60%, -75.5%) rotate(-13.5deg);
        }

        15% {
          transform: translate(-50%, -78.5%) rotate(-12.5deg);
        }

        30% {
          transform: translate(-40%, -80.5%) rotate(-6.5deg);
        }

        45% {
          transform: translate(-30%, -82.5%) rotate(-8.5deg);
        }

        60% {
          transform: translate(-20%, -80.5%) rotate(-6.5deg);
        }

        80% {
          transform: translate(-15%, -83.5%) rotate(-4.5deg);
        }
      }

      @keyframes truck-animation-6 {
        from {
          transform: translate(-10%, -85.5%) rotate(-2.5deg);
        }

        15% {
          transform: translate(0%, -87.5%) rotate(0.5deg);
        }

        30% {
          transform: translate(15%, -91.5%) rotate(-3.5deg);
        }

        45% {
          transform: translate(30%, -94.5%) rotate(0.5deg);
        }

        60% {
          transform: translate(45%, -100.5%) rotate(-3.5deg);
        }

        80% {
          transform: translate(60%, -98.5%) rotate(4deg);
        }
      }
    }

    &--front-rocks {
      background-image: url('../assets/images/foreground rocks 1.png');
      height: 391px;
      max-width: 1920px;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);

      @include media-breakpoint-down(md) {
        background-image: url('../assets/images/foreground -rocks-m.png');
        height: 250px;
        left: auto;
        right: 0;
        transform: translateX(0);
      }

      @include media-breakpoint-down(sm) {
        height: 160px;
      }
    }

    &--cloud-1 {
      background-image: url('../assets/images/cloud 1.png');
      height: 272px;
      max-width: 471px;
      top: -120px;
      left: 50%;
      transform: translateX(-180%);
      background-size: contain;
      transition: transform 1s ease-in-out;

      .SignUp--vehicleinfo & {
        transform: translateX(-181%);
      }

      .SignUp--tireinfo & {
        transform: translateX(-182%);
      }

      .SignUp--gearinfo & {
        transform: translateX(-183%);
      }

      .SignUp--contactinfo & {
        transform: translateX(-185%);
      }

      .SignUp--socialinfo & {
        transform: translateX(-187%);
      }

      .SignUp--enthusiastinfo & {
        transform: translateX(-190%);
      }
    }

    &--cloud-2 {
      background-image: url('../assets/images/cloud 3.png');
      height: 379px;
      max-width: 700px;
      top: -160px;
      left: 50%;
      transform: translateX(-30%);
      background-size: contain;
      transition: transform 2s ease-in-out;

      @include media-breakpoint-down(sm) {
        top: -150px;
      }

      .SignUp--vehicleinfo & {
        transform: translateX(-32%);
      }

      .SignUp--tireinfo & {
         transform: translateX(-36%);
      }

      .SignUp--gearinfo & {
         transform: translateX(-42%);
      }

      .SignUp--contactinfo & {
         transform: translateX(-45%);
      }

      .SignUp--socialinfo & {
         transform: translateX(-52%);
      }

      .SignUp--enthusiastinfo & {
         transform: translateX(-57%);
      }
    }

    &--cloud-3 {
      background-image: url('../assets/images/cloud 2.png');
      height: 182px;
      max-width: 296px;
      top: 40px;
      left: 50%;
      transform: translateX(150%);
      background-size: contain;
      transition: transform 1.6s ease-in-out;

      .SignUp--vehicleinfo & {
        transform: translateX(149%);
      }

      .SignUp--tireinfo & {
        transform: translateX(147%);
      }

      .SignUp--gearinfo & {
        transform: translateX(146%);
      }

      .SignUp--contactinfo & {
        transform: translateX(144%);
      }

      .SignUp--socialinfo & {
        transform: translateX(138%);
      }

      .SignUp--enthusiastinfo & {
        transform: translateX(132%);
      }
    }

    &--edges {
      width: 1920px;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
      pointer-events: none;

      @include media-breakpoint-down(md) {
        display: none;
      }

      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 100px;
        height: 100%;
      }

      &::before {
        left: 0;
        background: linear-gradient(to right,
          black 0%,
          black 27%,
          rgba(0, 0, 0, 0.5) 70%,
          transparent 100%);
      }

      &::after {
        right: 0;
        background: linear-gradient(to right,
          transparent 0%,
          rgba(0, 0, 0, 0.5) 30%,
          black 63%,
          black 100%);
      }
    }
  }

  &__button {
    min-width: 343px;
    @include media-breakpoint-down(md) {
      min-width: 265px;
    }
  }

  &__button-label {
    @include media-breakpoint-down(md) {
      visibility: hidden;
      display: none;
    }
  }

  &__button-icon {
    display: none;

    @include media-breakpoint-down(md) {
      display: inline-block;
    }
  }

  &__footer {
    position: fixed;
    background: black;
    bottom: 0;
    width: 100%;
    z-index: 100;
  }

  &__main {
    position: relative;
    z-index: 10;
  }

  &__page {
    margin-top: 100px;

    @include media-breakpoint-down(md) {
      margin-top: 30px;
    }
  }

  footer {
    ul {
      list-style: none;
      text-align: center;
    }

    li {
      display: inline-block;
      padding-right: 10px;
    }

    a, span, button {
      color: white;
      font-size: 14px;
    }
    button {
      @extend %roboto-font-regular;
      border: none;
      text-transform: none;
      background: none;
      &:focus {
        box-shadow: 0 0 0 1px white;
        border-radius: 0;
      }
    }
    a, button {
      text-decoration: underline;
    }
  }
}
</style>
